var datepicker = {
    MuiDatePicker: {
        defaultProps: {
            displayWeekNumber: true,
            sx: {}
        }
    }
};
export default datepicker;
